import React, { useState } from "react";
import CommentHeader from "./CommentHeader";
import CommentCard from "./CommentCard";
import Button from "../../sharedComponents/buttons/button";
import Lang from "../../../userPreferences/staticWords";

export default function CommentSection({
  items = [],
  lang,
  onAddComment,
  procedureCount,
}) {
  const [showAll, setShowAll] = useState(false);

  if (!items.length) {
    return (
      <div
        style={{
          backgroundColor: "#F2F2F2",
          borderRadius: 10,
          marginRight: 20,
        }}
      >
        <CommentHeader
          procedureCount={procedureCount}
          lang={lang}
          onAddComment={() => onAddComment(items.id)}
        />
      </div>
    );
  }

  const firstComment = items[0];
  const remainingComments = items.slice(1);

  return (
    <div
      style={{
        backgroundColor: "#F2F2F2",
        borderRadius: 10,
        marginRight: 20,
        marginBottom: 20,
      }}
    >
      <CommentHeader
        procedureCount={procedureCount}
        lang={lang}
        onAddComment={() => onAddComment(items.id)}
      />

      {/* First comment */}
      <CommentCard
        key={firstComment.id}
        procedure={firstComment}
        createDate={firstComment.createDate}
      />

      {/* Remaining comments */}
      {showAll &&
        remainingComments.map((procedure) => (
          <CommentCard
            key={procedure.id}
            procedure={procedure}
            createDate={procedure.createDate}
          />
        ))}

      {/* Toggle button */}
      {remainingComments.length > 0 && (
        <div className="d-flex  justify-content-center">
          <Button
            buttonStyleType={"solid"}
            inputStyle={"col-10"}
            containerStyle={
              "col-xl-2 col-md-3 col-sm-4 col-5 mt-2 px-3 py-2 mb-2"
            }
            onClick={() => setShowAll((prev) => !prev)}
            content={showAll ? Lang.collapse : Lang.seeMore}
          />
        </div>
      )}
    </div>
  );
}
